<template>
  <div>
    <label v-if="label && !disabled" class="data-label" :class="labelClass">
      {{ label }}
    </label>
    <div
      v-if="!disabled"
      class="position-relative"
      :class="prependIcon != null ? 'input-group' : ''"
    >
      <div
        v-if="prependIcon != null && prependIconLeft"
        class="input-group-prepend"
        :class="prependIconType"
      >
        <span class="input-group-text" @click="$emit('prepend-icon-click')">
          <i :class="prependIcon" />
          <span v-if="prependIconText" class="ml-1">{{ prependIconText }}</span>
        </span>
      </div>
      <money
        v-if="maskType == 'Money'"
        v-model="moneyValue"
        v-money="money"
        class="form-control"
        :class="computedClassInput"
        @input="$emit('input', moneyValue)"
      />
      <input
        v-else
        v-mask="inputMask"
        :class="computedClassInput"
        :disabled="disabled"
        :max="max"
        :maxlength="maxlength"
        :min="min"
        :minlength="minlength"
        :placeholder="placeholder"
        :required="required"
        :step="step"
        :type="type"
        :value="value"
        @blur="$emit('blur', $event)"
        @focus="$emit('focus', $event)"
        @input="emitValue($event.target.value)"
        @keypress.enter="$emit('keypress', $event)"
      />
      <div
        v-if="prependIcon != null && !prependIconLeft"
        class="input-group-prepend cursor-pointer"
        :class="prependIconType"
      >
        <span
          class="input-group-text rounded-right"
          @click="$emit('prepend-icon-click')"
        >
          <i :class="prependIcon" />
          <span v-if="prependIconText" class="ml-2">{{ prependIconText }}</span>
        </span>
      </div>
      <em
        v-if="icon && !error && !isValid"
        class="form-control-icon-normal"
        :class="computedEmClass"
      />
      <i v-if="isValid" :class="computedIconClass" />
    </div>
    <!-- TODO: en refactorizacion, deberia tener una posicion absoluta -->
    <error
      v-if="error && !disabled"
      :class="errorClass"
      :message="errorMessage"
      variant="no-border"
    />

    <custom-input-display
      v-if="disabled"
      v-model="value"
      :label="label"
      :mask-type="maskType"
    />
  </div>
</template>

<script>
import { mask } from 'ke-the-mask';
import Error from '@/components/common/Error';
import { Money, VMoney } from 'v-money';

import CustomInputDisplay from '@/components/common/form/CustomInputDisplay';

export default {
  name: 'CustomInput',
  meta: {
    description: 'Componente para entrada de datos',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Error,
    CustomInputDisplay,
    Money,
  },
  directives: {
    mask,
    money: VMoney,
  },
  props: {
    type: {
      type: String,
      default: 'text',
      meta: {
        description: 'Propiedad type personalizada',
        example: 'Texto requerido',
      },
    },
    label: {
      type: String,
      default: '',
      meta: {
        description: 'Control para mostrar texto ',
        example: 'Texto requerido',
      },
    },
    labelClass: {
      type: String,
      default: '',
      meta: {
        description: 'Clases para el label',
        example: 'Texto requerido',
      },
    },
    errorClass: {
      type: String,
      default: () => '',
    },
    placeholder: {
      type: String,
      default: '',
      meta: {
        description: 'Texto de referencia en el input',
        example: 'Texto requerido',
      },
    },
    value: {
      type: [String, Number],
      default: '',
      meta: {
        description: 'Parámetro de entrada en el input',
        example: 'Texto requerido',
      },
    },
    required: {
      type: String,
      default: function() {
        return '';
      },
      meta: {
        description: 'Estado requerido',
        example: 'required',
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: 'Estado deshabilitado',
        example: 'disabled',
      },
    },
    customDisabled: {
      type: Boolean,
      default: false,
      meta: {
        description:
          'Esta debera ser la prop para mostrar custom input display', // y así dejar el comportamiento habitual de un input para cuando se necesite.
        example: '',
      },
    },
    minlength: {
      type: String,
      default: '',
      meta: {
        description: 'Logitud mínima requerida',
        example: 'Texto requerido',
      },
    },
    maxlength: {
      type: String,
      default: '',
      meta: {
        description: 'Logitud máxima requerida',
        example: 'Texto requerido',
      },
    },
    min: {
      type: Number,
      default: 0,
      meta: {
        description: 'Límite mínimo  en el input ',
        example: '14',
      },
    },
    max: {
      type: Number,
      default: 100,
      meta: {
        description: 'Límite máximo en el input ',
        example: '14',
      },
    },
    step: {
      type: Number,
      default: 1,
      meta: {
        description: 'Rango de intervalos ',
        example: '14',
      },
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado error',
        example: 'Texto requerido',
      },
    },
    dirty: {
      type: Boolean,
      default: function() {
        return false;
      },
      meta: {
        description: 'Mostrar el checkmark si la validación es correcta',
        example: 'true',
      },
    },
    icon: {
      type: String,
      default: '',
      meta: {
        description: 'Propiedad para el icono ',
        example: 'fas fa-user-edit',
      },
    },
    customErrorMsg: {
      type: String,
      default: null,
      meta: {
        description: 'Personalización para mensajes de error',
        example: 'Texto requerido',
      },
    },
    maskType: {
      type: String,
      default: '',
      meta: {
        description: 'Máscaras del texto',
        example: 'Texto requerido',
      },
    },
    masked: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Condicional para Enmascarar texto',
        example: 'true',
      },
    },
    canModifyCss: {
      type: Boolean,
      default: true,
      meta: {
        description: 'Control modificación ',
        example: 'true',
      },
    },
    leftIcon: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Muestra el icono a la izquierda',
        example: 'true',
      },
    },
    prependIcon: {
      type: String,
      default: () => null,
    },
    prependIconType: {
      type: String,
      default: () => 'success',
    },
    prependIconText: {
      type: String,
      default: () => null,
    },
    prependIconLeft: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      maskTypes: [
        { id: 'Phone', mask: '(###) ###-####' },
        { id: 'Date', mask: '##/##/####' },
        { id: 'Zipcode', mask: '#####' },
        { id: 'PhoneExt', mask: '#####' },
        { id: 'ZipcodeExt', mask: '#####-####' },
        { id: 'Day', mask: '##' },
        { id: 'Personalssn', mask: '###-##-####' },
        { id: 'Price' },
        { id: 'Money' },
      ],
      inputMask: '',
      formControlClass: 'form-control',
      errorMessage:
        this.customErrorMsg == null ? this.error : this.customErrorMsg,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      moneyValue: 0.0,
    };
  },
  computed: {
    isValid() {
      return !this.error && this.dirty;
    },
    computedClassInput() {
      let result = '';

      if (this.error) {
        result = ' was-Invalidated';
      } else if (this.isValid && this.canModifyCss) {
        result = ' was-validated';
      }

      if (this.leftIcon) {
        result = `${result} leftInput`;
      }
      return this.formControlClass + result;
    },
    computedEmClass() {
      let result = this.icon;

      if (this.leftIcon) {
        result = `${result} left`;
      }

      return result;
    },
    computedIconClass() {
      let result = 'form-control-icon-normal far fa-lock-alt';

      if (this.canModifyCss) {
        if (this.isValid) {
          result = 'fa fa-checkmark sucess-icon';
        }
      }

      return result;
    },
  },
  watch: {
    error: function(newValue) {
      if (this.customErrorMsg == null) this.errorMessage = newValue;
    },
    customErrorMsg: function(newValue) {
      this.errorMessage = newValue;
    },
  },
  mounted() {
    if (this.maskType != undefined) {
      let mask = this.maskTypes.find((x) => x.id == this.maskType);
      this.inputMask = mask != undefined ? mask.mask : '';
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit('input', value);
    },
    emitValue(value) {
      if (this.maskType == undefined || this.masked) {
        this.$emit('input', value);
        return;
      }

      let sentVal = this.formatMaskedText(value);

      if (sentVal == '') sentVal = null;

      this.$emit('input', sentVal);
    },
    formatMaskedText(value) {
      //conditionals to remove masks from text
      if (this.maskType == 'Phone') {
        return value.replace(/-|[()]/gi, '');
      } else if (this.maskType == 'Price') {
        if (!isNaN(value)) {
          let val = (value / 1).toFixed(2);
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '');
        }
      }

      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.input-group-prepend.success span {
  background-color: map-get($colors, 'green');
  color: white;
}

.leftInput {
  padding-left: 40px;
}
.sucess-icon {
  font-size: 19px;
  position: absolute;
  top: 9px;
  right: 7px;
  color: map-get($colors, 'grey-7');
  margin-right: 0.2rem;
}
.sucess-icon:before {
  content: '\f058';
  color: map-get($colors, 'green');
}
span.invalid:not(input) {
  color: #e85c5c;
}
.form-control-icon-normal {
  position: absolute;
  top: 9px;
  right: 10px;
  color: map-get($colors, 'grey-7');
  margin-right: 0.2rem;
}
.form-control-icon-normal.left {
  left: 15px;
  top: 11px;
  width: 20px;
}

.form-control-icon-invalid {
  color: #e85c5c;
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 19px;
}
.input-label {
  height: 19px;
  text-align: left;
  font: Bold 16px/21px Lato !important;
  letter-spacing: 0;
  color: #11291b;
  line-height: 19px;
}

.form-control:disabled {
  background: white;
  cursor: not-allowed;
}

.modal-label {
  font-weight: 300;
  font-family: normal;
}

.custom-error i {
  float: left;
  margin-top: 15px;
  margin-right: 10px;
  color: #e85c5c;
}

.was-Invalidated {
  border: 1px solid #ff0018 !important;
}

.orange-icon {
  color: #ff7058;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
